import { AIAvatarServiceApi } from 'api/AIAvatarServiceApi';
import { aiAvatarClient } from 'container/aiAvatarClient';

export const aiAvatarServiceApi = new AIAvatarServiceApi(aiAvatarClient);
